__webpack_require__.p = "/logy/";